import React, { createContext, useContext } from 'react';
import {
  useWizardState,
  WizardStateInterface,
} from '../../hooks/useWizardState';

export type OutcomeWizardInterface = WizardStateInterface;

export const OutcomeWizardContext = createContext<
  OutcomeWizardInterface | undefined
>(undefined);

export const useOutcomeWizardContext = () => {
  const context = useContext(OutcomeWizardContext);
  if (context === undefined) {
    throw new Error(
      'useOutcomeWizardContext must be used within a OutcomeWizardProvider'
    );
  }
  return context;
};

type Props = {
  children: React.ReactNode;
};

export const OutcomeWizardProvider = ({ children }: Props) => {
  const wizardState = useWizardState();

  return (
    <OutcomeWizardContext.Provider value={wizardState}>
      {children}
    </OutcomeWizardContext.Provider>
  );
};
